import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ExtrasState } from '@/store/extras/types';
import actions from './actions';
import mutations from './mutations';

const Extras: Module<ExtrasState, RootState> = {
  actions,
  mutations,
  state: (): ExtrasState => ({
    extras: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
};

export default Extras;
